import { Card, WalletAddress } from '@blockanalitica/ui';
import { WalletAddressProps } from '@blockanalitica/ui/package/types/src/components/molecules/WalletAddress';

export default function WalletCard({
  address,
  options
}: {
  address: string;
  options?: WalletAddressProps['options'];
}) {
  return (
    <Card display="flex" flexDirection="row">
      <WalletAddress
        options={{
          showCopyBtn: true,
          showDebankLink: true,
          showEthScanLink: true,
          showZapperLink: true,
          sizes: {
            blockie: '5',
            walletAddressHeader: '2'
          },
          ...options
        }}
        address={address}
      />
    </Card>
  );
}
